export enum StorageKeys {
  connectionId = 'connection_id',
}
